import { en, type StringKey } from './en.js';
import { ar } from './ar.js';

export type Lang = 'en' | 'ar';
export type Numerals = 'latn' | 'arab';

export const DICTS: Record<Lang, Record<StringKey, string>> = { en, ar };

export const isRtl = (lang: Lang): boolean => lang === 'ar';

const ARABIC_INDIC = '٠١٢٣٤٥٦٧٨٩';

/**
 * Numerals are a display concern only — the engine never sees them, which is
 * why a tile's `value` stays a plain number and only its rendering changes.
 */
export function formatNumber(n: number | string, numerals: Numerals): string {
  const s = String(n);
  return numerals === 'arab' ? s.replace(/[0-9]/g, (d) => ARABIC_INDIC[Number(d)]!) : s;
}

export type Translate = (key: StringKey, vars?: Record<string, string | number>) => string;

export function makeTranslate(lang: Lang, numerals: Numerals): Translate {
  const dict = DICTS[lang];
  return (key, vars) => {
    let out: string = dict[key] ?? en[key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        out = out.replaceAll(`{${k}}`, typeof v === 'number' ? formatNumber(v, numerals) : v);
      }
    }
    return out;
  };
}

export type { StringKey };
